import { States } from '../../app.router';

/* @ngInject */
export default function projectsRouter($stateProvider) {
    $stateProvider
        .state(States.NEW_USER_FLOW, {
            url: '/no-organization',
            views: {
                content: {
                    component: 'dtNewUserFlow'
                }
            }
        })
}
